import { forwardRef, ForwardRefRenderFunction } from 'react';

import { Spinner } from 'baseui/spinner';
import clsx from 'clsx';
import { DateTime } from 'luxon';

import { ListDealMessages_dealMessages_entities } from './fragments';

interface MessageProps {
  dealMessage: NonNullable<ListDealMessages_dealMessages_entities>;
  isLoading?: boolean;
}

const UnwrappedMessage: ForwardRefRenderFunction<HTMLDivElement, MessageProps> = (
  { dealMessage, isLoading },
  ref,
) => {
  if (isLoading) {
    return (
      <div className="flex flex-col">
        <div className="white-space-pre-wrap rounded-b-lg bg-gray-950 p-4 shadow-md shadow-black">
          <div className="flex w-full justify-center">
            <Spinner color="#e85ee5" aria-label="loading more messages" />
          </div>
        </div>
      </div>
    );
  }
  const { given_name, family_name, is_current_user } = dealMessage.author;
  return (
    <div className="flex flex-col" ref={ref}>
      <div className="flex flex-col items-start p-0">
        <div
          className={clsx(
            'text-sm font-medium not-italic',
            is_current_user ? 'text-white' : 'text-gray-500',
          )}
        >{`${given_name} ${family_name || ''}`}</div>
        <div className="text-xs font-normal leading-5 text-gray-600">
          {DateTime.fromSeconds(Number(dealMessage.created_time)).toFormat('MM-dd-yy @ h:mma')}
        </div>
      </div>
      <div className="white-space-pre-wrap rounded-b-lg bg-gray-950 p-4 shadow-md shadow-black">
        {dealMessage.message}
      </div>
    </div>
  );
};

export const Message = forwardRef(UnwrappedMessage);
